<div class="wrapper" [class.redirect-spinner]="loginRedirectSpinner">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner
        [whiteMode]="whiteMode"
      ></app-spinner>
    </div>
  </div>

  <div class="loaded-content" [class.blurred]="showSpinner">
    <ng-content></ng-content>
  </div>
</div>
